import { useContext, useEffect, useState } from "react";

import { Outlet } from "react-router-dom";

import "../../components/styles/Dashboard.css";

import Sidebar from "components/SideBar";
import TopNav from "components/TopNav";
import { AuthCtx } from "context/AuthContext";

export type currentUser = {
  uid?: string;
  displayName?: string;
  email?: string;
};

const Layout = () => {
  // const [currentUser, setCurrentUser] = useState<currentUser>();
  const [currentUserDetails, setCurrentUserDetails] = useState<any>();
  // const [openMenu, setOpenMenu] = useState(true);
  const { user } = useContext(AuthCtx);

  const [collapse, setCollapse] = useState(true);

  return (
    <section className="wrapper">
      <Sidebar
        userDetails={{
          displayName: user?.username,
          email: user?.email,
        }}
        collapse={collapse}
        setCollapse={setCollapse}
      />
      <main className={`page-content ${collapse && "collapsePageContent"}`}>
        <TopNav currentUserDetails={currentUserDetails} />
        <div className="pageTemplate">
          <section className="content">
            <Outlet />
          </section>
          <p className="text-center copyright">Copyright © Eningo 2025</p>
        </div>
      </main>
    </section>
  );
};

export default Layout;
